import GoogleMapsLoader from "google-maps";
import MarkerClusterer from '@google/markerclusterer';

export const mapUtilities = {
    async initMap(mapRef, callback) {
        GoogleMapsLoader.KEY = 'AIzaSyBULgN2oWltDQFqUfdnoAFSg76UcLTbvvM';
        GoogleMapsLoader.LIBRARIES = ['places'];
        GoogleMapsLoader.VERSION = '';
        let self = this;
        GoogleMapsLoader.load(function (google) {
            let map = new google.maps.Map(mapRef, {
                zoom: 5,
                center: {lat: 39.828473, lng: -98.579483}
            });
            callback(map, google);
        });
    },
    async initMarkers(map, googleMapsObject, locations) {
        let markers = [];
        for (let i = 0; i < locations.length; i++) {
            let current = locations[i];
            let point = new googleMapsObject.maps.LatLng(current.latitude, current.longitude);
            let marker = new googleMapsObject.maps.Marker({
                map: map,
                draggable: false,
                position: point,
                title: '',
            });
            markers.push(marker);
        }
        return markers;
    },
    async initClusters(map, googleMapsObject, coordinates) {
        let styles = [
            {
                url: require('@/assets/images/MapClusters/cluster35.png'),
                height: 35,
                width: 35,
                anchorText: [16, 0],
                textColor: 'white',
                textSize: 12,
                fontFamily: "proxima-nova,Roboto,Arial,Helvetica"
            },
            {
                url: require('@/assets/images/MapClusters/cluster45.png'),
                height: 45,
                width: 45,
                anchorText: [24, 0],
                textColor: 'white',
                textSize: 14,
                fontFamily: "proxima-nova,Roboto,Arial,Helvetica"
            },
            {
                url: require('@/assets/images/MapClusters/cluster55.png'),
                height: 55,
                width: 55,
                anchorText: [32, 0],
                textColor: 'white',
                textSize: 16,
                fontFamily: "proxima-nova,Roboto,Arial,Helvetica"
            }
        ];
        let markers = coordinates.map(function (location, i) {
            return new googleMapsObject.maps.Marker({
                position: new googleMapsObject.maps.LatLng(location.latitude, location.longitude),
                label: "",
                icon: require('@/assets/images/MapClusters/cluster35.png')
            });
        });
        new MarkerClusterer(map, markers, {styles});
    },

};